import { tv } from "@/utils/tv.config";

export const cardHeaderClasses = tv({
  base: ["Card__Header p-5"],
  variants: {},
});
